import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

const errText = (e) => e?.response?.data?.detail || "Eroare";
const STUDY = { L: "Licență", M: "Masterat", D: "Doctorat", R: "Rezidențiat" };

/** Vedere de ansamblu a formațiunilor unui an universitar: pe fiecare program și an de studiu, seriile și, sub fiecare, grupele
 *  (preclinice, clinice, complementare, de seminar, aplicative), cu efectivele și totalurile pe tip. Editarea rămâne în fila „Efective și editare”. */
export default function CohortsOverview({ yearId, programId }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    if (!yearId) return;
    setData(null); setError("");
    api.get("/stat-didactic/cohorts/overview", { params: { year_id: yearId, ...(programId ? { program_id: programId } : {}) } })
      .then(r => setData(r.data)).catch(e => { setError(errText(e)); setData({ items: [], labels: {} }); });
  }, [yearId, programId]);
  if (data === null) return <div>Se încarcă...</div>;
  if (error) return <div className="card" style={{ padding: 16, color: "#991B1B" }}>{error}</div>;
  if (data.items.length === 0) return <div className="card" style={{ padding: 24, color: "#64748B" }} data-testid="sfd-ov-empty">Nu există încă efective pentru acest an universitar{programId ? " și program" : ""}. Le introduci din fila „Efective și editare”.</div>;
  const label = (k) => (k === "serie" ? "Serii" : `Grupe ${data.labels[k] || k}`);
  const groups = (list) => (list && list.length ? list.map((g, i) => <div key={i} style={{ whiteSpace: "nowrap" }}>{g.name} <span style={{ color: "#64748B" }}>({g.students})</span></div>) : <span style={{ color: "#94A3B8" }}>—</span>);
  return (
    <div style={{ display: "grid", gap: 16 }} data-testid="sfd-ov">
      {data.items.map(it => (
        <div className="card" key={it.cohort_id} style={{ padding: 0, overflowX: "auto" }} data-testid={`sfd-ov-card-${it.cohort_id}`}>
          <div style={{ padding: "12px 16px", display: "flex", gap: 12, alignItems: "baseline", flexWrap: "wrap", borderBottom: "1px solid #E2E8F0" }}>
            <b>{it.program.name}</b>
            <span style={{ color: "#64748B", fontSize: 13 }}>{STUDY[it.program.study_type] || it.program.study_type} · Anul {it.study_year} · {it.students_count} studenți</span>
            {it.warnings.length > 0 && <span style={{ color: "#92400E", fontSize: 12 }} title={it.warnings.join("\n")}>⚠ {it.warnings.length} avertismente</span>}
            <Link to={`/stat-didactic/formatiuni/${it.cohort_id}`} style={{ marginLeft: "auto", fontSize: 13 }}>Editează →</Link>
          </div>
          <table className="tbl" style={{ margin: 0 }}>
            <thead><tr><th>Seria</th><th>Studenți</th>{it.kinds.map(k => <th key={k}>{label(k)}</th>)}</tr></thead>
            <tbody>
              {it.series.map(s => (
                <tr key={s.id}><td style={{ fontWeight: 700 }}>{s.name}</td><td>{s.students}</td>{it.kinds.map(k => <td key={k}>{groups(s.groups[k])}</td>)}</tr>))}
              {it.kinds.some(k => (it.ungrouped[k] || []).length) && (
                <tr><td style={{ fontStyle: "italic" }}>Fără serie</td><td>—</td>{it.kinds.map(k => <td key={k}>{groups(it.ungrouped[k])}</td>)}</tr>)}
              <tr style={{ background: "#F8FAFC", fontWeight: 600 }}>
                <td>Total</td><td>{it.totals.serie.count} serii · {it.totals.serie.students}</td>
                {it.kinds.map(k => <td key={k}>{it.totals[k].count} grupe · {it.totals[k].students} studenți</td>)}</tr>
            </tbody>
          </table>
        </div>))}
    </div>
  );
}
